import { render, staticRenderFns } from "./LessonItemMain.vue?vue&type=template&id=34047c9e&scoped=true"
import script from "./LessonItemMain.vue?vue&type=script&lang=js"
export * from "./LessonItemMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34047c9e",
  null
  
)

export default component.exports